export default {
	revenu: "blue",
	prestations: "green",
	benefices: "teal",
	prelevements: "red"
};
